import { ITimeInputControl } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../../infrastructure/providers/abstract/IApiProvider';
import {
  FormControlViewModelType,
  LocalizedProps,
  TimeInputFormControlViewModel,
} from '../../view-model/FormControlViewModel';
import { FormSourceType } from '../../view-model/FormSource';
import { FormViewModel } from '../../view-model/FormViewModel';

import { getControlValueHistory, getValueFromArgsOrConfig } from './helpers';

const buildTimeInputControl = async (
  item: ITimeInputControl,
  localizedProps: LocalizedProps,
  args: TActionArgsValues,
  viewModel: FormViewModel
): Promise<TimeInputFormControlViewModel> => ({
  columns: item.columns,
  type: FormControlViewModelType.TIME_INPUT,
  name: item.name,
  noLabel: item.noLabel,
  labelWidth: item.labelWidth,
  hasValue: true,
  hasHistory: true,
  value: getValueFromArgsOrConfig<number | null>(
    item,
    args,
    viewModel.source,
    null
  ),
  required: item.required,
  history: getControlValueHistory(viewModel.source, item.name),
  disabled: item.disabled,
  visible: item.visible,
  readonly: item.readonly || viewModel.source.type === FormSourceType.REVIEW,
  invalid: item.invalid,
  errorMessage: item.errorMessage,
  ...localizedProps,
});

export default buildTimeInputControl;
